"use client";

import _objectSpread from "G:\\aajubaaju.in\\aajubaajuweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "G:\\aajubaaju.in\\aajubaajuweb\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import FormGroup from './FormGroup';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FloatingLabel =
/*#__PURE__*/
React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      controlId = _ref.controlId,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "children", "controlId", "label"]);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-floating');
  return (
    /*#__PURE__*/
    _jsxs(FormGroup, _objectSpread({
      ref: ref,
      className: classNames(className, bsPrefix),
      controlId: controlId
    }, props, {
      children: [children,
      /*#__PURE__*/
      _jsx("label", {
        htmlFor: controlId,
        children: label
      })]
    }))
  );
});
FloatingLabel.displayName = 'FloatingLabel';
export default FloatingLabel;